var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const NPAggregateRowHeaderStyle = {
    root: {
        paddingTop: 0,
        width: '616px !important',
    },
};
export const NPAggregateRowCellStyle = {
    root: {
        width: '140px !important',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 600,
    }
};
export const NPChevronStyle = {
    root: {
        width: '40px',
        height: '48px',
        backgroundColor: 'white',
        color: '#605E5C',
    },
};
//# sourceMappingURL=GridGroupHeaderComponent.styles.js.map